// 管理直接更新states的方法
export default {
  // 存储访问端
  updateAgent(state, data) {
    sessionStorage.setItem("isWechat", data);
    if (sessionStorage.getItem("isWechat") == "false") {
      state.isWechat = false;
      return;
    }
    if (sessionStorage.getItem("isWechat") == "true") {
      state.isWechat = true;
      return;
    }
    state.isWechat = sessionStorage.getItem("isWechat");
  },
  // 存储selectedOrderId的值
  setselectedOrderId(state, data) {
    sessionStorage.setItem("selectedOrderId", data);
    state.selectedOrderId = sessionStorage.getItem("selectedOrderId");
  },
  //用户信息发生变化存储
  updateUserInfo(state, data) {
    state.user_id = data["user_id"];
    state.user_name = data["user_name"];
    state.user_tel = data["user_tel"];
    state.face = data["user_face"];
  },

  // 改变订阅消息的状态 用于watch监听
  subcribeMsg(state, data) {
    state.subscribeTag = data;
  },
  saveSubscribeData(state, data) {
    console.log("订阅标志:", data);
    state.sseData = data;
  }
};
